import { render, staticRenderFns } from "./TbWorkPermitInfo.vue?vue&type=template&id=28130689&scoped=true"
import script from "./TbWorkPermitInfo.vue?vue&type=script&lang=js"
export * from "./TbWorkPermitInfo.vue?vue&type=script&lang=js"
import style0 from "./TbWorkPermitInfo.vue?vue&type=style&index=0&id=28130689&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28130689",
  null
  
)

export default component.exports